import { render, staticRenderFns } from "./ItemTableList.vue?vue&type=template&id=202c1060&scoped=true"
import script from "./ItemTableList.vue?vue&type=script&lang=js"
export * from "./ItemTableList.vue?vue&type=script&lang=js"
import style0 from "./ItemTableList.vue?vue&type=style&index=0&id=202c1060&prod&scoped=true&lang=css"
import style1 from "./ItemTableList.vue?vue&type=style&index=1&id=202c1060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c1060",
  null
  
)

export default component.exports